import Api from '@/api'

export default {
  namespaced: true,
  state: {
    faq: ''
  },
  mutations: {
    setFaq(state, payload) {
      state.faq = payload
    }
  },
  actions: {
    async getFaq({ commit }) {
      const { data } = await Api.get('support-pages/faqs')
      commit('setFaq', data.data.content)
    }
  }
}
